const config = {
  // baseURL : 'http://10.20.0.2:5000/v1',
  // baseWS : 'ws://10.20.0.5',
  baseURL : 'https://api.f1secaas.co.kr/v1',
  baseWS : 'wss://ws.f1secaas.co.kr',
  // baseURL : 'https://api.f1secaas.net/v1',
  // baseWS : 'wss://ws.f1secaas.net',
  // baseURL : 'https://api.demo.uwss.jp/v1',
  // baseWS : 'wss://ws.demo.uwss.jp',
  manual : "f1-uwss.en.manager.manual.latest.pdf",
  startYear : 2019,
  version : "2022.05"
}

export default config;
